import * as React from 'react';
import styled from 'styled-components';
import { PageTransition } from '../../common/layout/PageTransition';
import { MissingData } from '../ui/MissingData';

const NoAccess: React.FC = () => {
  return (
    <PageTransition>
      <Page>
        <MissingData
          heading="Du har ikke tilgang til denne siden"
          text="<p>Har du spørsmål? Send dette til <a href='mailto:helpdesk@reeltime.no'>helpdesk@reeltime.no</a></p>"
        />
      </Page>
    </PageTransition>
  );
};

export default NoAccess;

const Page = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 30px;
`;
